"use client";

import React from "react";
import { Card, Box, Typography, List, ListItem, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProductPerformance = ({ data = [] }) => {
  const navigate = useNavigate();

  // Use provided data or fallback to empty array
  const topProducts = data.length > 0 ? data : [];

  return (
    <>
      {/* Top Performing Products */}
      <Card sx={{ boxShadow: "none", borderRadius: "7px", p: 3, mb: 3 }}>
        <Typography variant="h6" fontWeight={700} mb={2} className="text-black">
          Top Performing Products
        </Typography>
        <List sx={{ p: 0 }}>
          {topProducts.length > 0 ? (
            topProducts.map((product, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1.5,
                  borderBottom: index < topProducts.length - 1 ? "1px solid #ECEEF2" : "none",
                  cursor: "pointer",
                  "&:hover": { bgcolor: "#F8F9FA" }
                }}
                onClick={() => navigate("/products")}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography fontWeight={500}>{product.product_name || product.name}</Typography>
                </Box>
                <Chip
                  label={`${product.click_count || product.clicks} clicks`}
                  size="small"
                  sx={{ bgcolor: "#605DFF", color: "white" }}
                />
              </ListItem>
            ))
          ) : (
            <Typography color="text.secondary">No product data available</Typography>
          )}
        </List>
      </Card>
    </>
  );
};

export default ProductPerformance;